module.exports = __webpack_public_path__ + "img/Care3.80d55ae0.png";